import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
    return (
        <div className="bg-black min-h-screen font-sans text-gray-300 selection:bg-white selection:text-black">
            <Navbar />
            <div className="container mx-auto px-6 py-32 max-w-4xl">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Privacy Policy</h1>

                    <div className="space-y-8 leading-relaxed">
                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">1. Titolare del Trattamento</h2>
                            <p>
                                Il titolare del trattamento dei dati è <strong>ADER SRL</strong>, con sede legale in Via Don Danesin 6/A, Susegana (TV).
                                <br />
                                Email di contatto: <a href="mailto:adersrl0030@gmail.com" className="text-white hover:underline">adersrl0030@gmail.com</a>
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">2. Tipologia di Dati Raccolti</h2>
                            <p>
                                Durante la navigazione sul sito, potremmo raccogliere le seguenti tipologie di dati:
                            </p>
                            <ul className="list-disc pl-6 mt-4 space-y-2">
                                <li><strong>Dati di Navigazione:</strong> Indirizzi IP, log di sistema e altri parametri relativi al sistema operativo e all'ambiente informatico dell'utente (raccolti automaticamente per fini di sicurezza e statistica).</li>
                                <li><strong>Dati forniti volontariamente:</strong> Nome, indirizzo email e altri dati inseriti volontariamente dall'utente nel modulo di contatto o inviati tramite email per richieste di preventivo o informazioni.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">3. Finalità del Trattamento</h2>
                            <p>I dati raccolti vengono trattati per le seguenti finalità:</p>
                            <ul className="list-disc pl-6 mt-4 space-y-2">
                                <li>Rispondere alle richieste di informazioni o preventivi inviate dall'utente.</li>
                                <li>Garantire la sicurezza e il corretto funzionamento del sito web.</li>
                                <li>Adempiere agli obblighi di legge.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">4. Base Giuridica</h2>
                            <p>
                                Il trattamento dei dati personali si basa sul consenso dell'utente (per i dati forniti volontariamente) e sul legittimo interesse del Titolare (per i dati di sicurezza).
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">5. Conservazione dei Dati</h2>
                            <p>
                                I dati saranno conservati per il tempo strettamente necessario a conseguire gli scopi per cui sono stati raccolti, salvo obblighi di legge o legittimi interessi che impongano periodi di conservazione diversi.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">6. Diritti dell'Utente</h2>
                            <p>
                                In qualità di interessato, hai il diritto di chiedere al Titolare l'accesso ai tuoi dati personali, la rettifica, la cancellazione degli stessi, la limitazione del trattamento o di opporti al loro trattamento. Le richieste possono essere indirizzate a <a href="mailto:adersrl0030@gmail.com" className="text-white hover:underline">adersrl0030@gmail.com</a>.
                            </p>
                        </section>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
